import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const symantecEndpointSecurity = defineConnector({
  identifier: "symantecEndpointSecurity",
  name: "Symantec Endpoint Security",
  tagLine: "Cloud-managed endpoint security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ serverUrl }) =>
    urlToPattern(
      serverUrl,
      "https://[^/]*\\.securitycloud\\.symantec\\.com/.*"
    ),
  auth: oauthAuth,
  steps: [
    {
      title: "Create a client application in SES",
      items: [
        {
          kind: "markdown",
          content:
            "In the Symantec Endpoint Security console, go to **Integration → Client Applications**, click **Add**, create a client application, then open the application menu and select **Client Secret**. Copy the Client ID and Client secret.",
        },
      ],
    },
    {
      title: "Enter your SES API details",
      items: [
        {
          kind: "url",
          label: "SES API server URL",
          placeholder: "https://api.sep.securitycloud.symantec.com",
          required: true,
          helperText:
            "Use the API server URL Broadcom provides for your SES tenant or region.",
          target: { kind: "configuration", field: "serverUrl" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          helperText: "Paste the Client ID from **Client Applications**.",
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          helperText: "Paste the Client secret from **Client Applications**.",
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ serverUrl }) =>
      `${serverUrl || "https://api.sep.securitycloud.symantec.com"}/v1/oauth2/tokens`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) =>
      `${serverUrl || "https://api.sep.securitycloud.symantec.com"}/v1/devices`,
  },
});
